// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4259d711","239":"e7465fc0","455":"373b211a"}[chunkId] + ".chunk.js";
};